import React from 'react';
import './App.css';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import Address from './components/Address';
import Logo from './components/Logo';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import ReviewsPage from './components/ReviewsPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Care from './components/Care';
import Story from './components/Story';

function App() {
  return (
    <Router>
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Logo />
        <Routes>
          <Route path="/" element={
            <>
              <About />
              <Reviews />
              <Services />
              <Address />
              <Contact />
            </>
          } />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/care" element={<Care />} />
          <Route path="/story" element={<Story />} />
          <Route path="/reviews" element={<ReviewsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
